<script lang="ts">
	import theme from 'stores/theme';

	export let price: { initial: string; formatted: string };
	export let alignStart = false;
	export let verticalAlign: 'center' | 'flex-start' | 'flex-end' = 'center';
	export let tooltipAlign: 'left' | 'right' = 'left';
	let className = null;
	export { className as class };
	let isActive = false;
	function handleClick() {
		isActive = !isActive;
	}
	$: dark = $theme;
</script>

{#if price?.formatted}
	<div
		class={`price-wrapper ${className || ''}`}
		class:is-active={isActive}
		class:align-start={alignStart}
		class:dark
		on:click={handleClick}
		style={`align-items: ${verticalAlign}`}
	>
		<p class="price">{price?.formatted}</p>
		<p class={`tooltip ${tooltipAlign}`}>{price?.initial}</p>
	</div>
{:else}
	{price?.initial}
{/if}

<style lang="scss">
	@import './priceTooltip.scss';
</style>
